import React from "react";

/**
 * "Is there a System Error?" input + "Other issue" textarea.
 * Both are driven by the same onChange handler (matched by input id),
 * matching the pattern used by the modal's handleInputChange. Uncontrolled
 * on purpose, matching the original markup.
 */
const IssueDetailsFields = ({ onChange }) => (
  <>
    <div className="form-field">
      <label>Is there a System Error? (Error 1-18)</label>
      <input type="text" onChange={onChange} id="systemError" />
    </div>
    <div className="form-field">
      <label>Other issue, please describe in details*</label>
      <textarea required onChange={onChange} id="otherIssue" />
    </div>
  </>
);

export default IssueDetailsFields;
